import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-maintenance-reforms',
  templateUrl: './maintenance-reforms.component.html',
  styleUrls: ['./maintenance-reforms.component.sass']
})
export class MaintenanceReformsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
